import React from 'react';

import { Modal, BlockStack, Text } from '@shopify/polaris';

const DeleteLoginCodeDialog = ({ loginCode, displayDeleteLoginCodeDialog, setDisplayDeleteLoginCodeDialog, deleteLoginCode, setSubmitted }) => {
  const submit = () => {
    deleteLoginCode(loginCode);
    setSubmitted(true);

    close();
  }

  const close = () => {
    setDisplayDeleteLoginCodeDialog(false);
  }

  return(
    <Modal
      open={displayDeleteLoginCodeDialog}
      onClose={() => close()}
      title="Delete Login Code"
      primaryAction={{
        content: 'Delete Login Code',
        destructive: true,
        onAction: () => submit(),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => close()
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="200">
          <Text as="h3" variant="headingSm">Login Code</Text>

          <Text as="p">
            {loginCode.loginCode}
          </Text>

          <Text as="p">
            {loginCode.locationLabel}
          </Text>
        </BlockStack>
      </Modal.Section>
    </Modal>
  )
}

export default DeleteLoginCodeDialog;
